import { computed } from 'vue';
import { useStore } from 'vuex';
import { useProduct } from '@modules/product';
import SelectedLatchkeyParser from '../parsers/SelectedLatchkeyParser';
import { getFirstUpcIdFromSelectedLatchkey } from '../utils';

function set(store, { key, value }) {
  store.commit('extraStore/set', { scope: 'latchkey', key, value });
}

/**
 * WARNING: doesn't support more then 1 latchkey product id per page. Fix if needed
 */
function useSelectedLatchkey() {
  const { productData: product } = useProduct();
  const store = useStore();

  const { initialized } = store.state.extraStore.latchkey;
  if (!initialized) {
    set(store, { key: 'initialized', value: true });

    const selectedLatchkey = SelectedLatchkeyParser(product) || '';
    set(store, { key: 'selectedLatchkey', value: selectedLatchkey });
    const firstUpcIdForSelectedLatchkey = getFirstUpcIdFromSelectedLatchkey(product, selectedLatchkey) || '';
    set(store, { key: 'firstUpcIdForSelectedLatchkey', value: firstUpcIdForSelectedLatchkey });
  }

  return computed({
    get() {
      return store.state.extraStore.latchkey.selectedLatchkey;
    },
    set(value) {
      const previousSelectedLatchkey = store.state.extraStore.latchkey.selectedLatchkey;
      const firstUpcIdForSelectedLatchkey = getFirstUpcIdFromSelectedLatchkey(product, value) || '';
      set(store, { key: 'previousSelectedLatchkey', value: previousSelectedLatchkey });
      set(store, { key: 'selectedLatchkey', value });
      set(store, { key: 'firstUpcIdForSelectedLatchkey', value: firstUpcIdForSelectedLatchkey });
    },
  });
}

export default useSelectedLatchkey;
